import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  InputLabel,
  TextField,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";
import api from "../../interceptors/axios";
import Cookies from "js-cookie";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import LocalIP from "../../api/LocalIP";

const SignIn = ({ history }) => {
  //const { setAuth } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      toast.error("Please enter an email.");
      return false;
    }
    if (!emailRegex.test(value)) {
      toast.error("Please enter a valid email address.");
      return false;
    }
    return true;
  };

  const validatePassword = (value) => {
    if (value.length === 0) {
      toast.error("Please enter the password.");
      return false;
    }
    setPasswordError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isEmailValid = validateEmail(email);
    if (!isEmailValid) {
      return; 
    }

    const isPasswordValid = validatePassword(password);
    if (!isPasswordValid) {
      return; // Stop further execution if password is invalid
    }

      try {
        const { data } = await api.post(LocalIP + "/user/login", {
          email,
          password,
        });
        // Set tokens as session cookies
        Cookies.set("accessToken", data.data.accessToken, { expires: 7 });
        Cookies.set("refreshToken", data.data.refreshToken, { expires: 7 });
        Cookies.set("fullName", data.data.fullName, { expires: 7 });
        Cookies.set("userRole", data.data.type, { expires: 7 });
        Cookies.set("lastLogin", data.data.lastLogin, { expires: 7 });
        Cookies.set("isEntExcluded", data.data.isEntExcluded, { expires: 7 });
        Cookies.set("code", data.data.code, { expires: 7 });
        // document.cookie = `accessToken=${data.data.accessToken}; path=/;`;
        // document.cookie = `refreshToken=${data.data.refreshToken}; path=/;`;

        navigate("/home");
        if (data.statusCode === 200) {
          setEmail("");
          setPassword("");
          toast.success(data.message);
        }
      } catch (err) {
        console.error("Login error:", err);
        const errorMessage = err.response?.data?.message || 
          "Failed to connect to the server. Please check your connection.";
        toast.error(errorMessage);    
      }
  };
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  return (
    <div
      className="grid grid-flow-row sm:grid-flow-col gap-0.5 font-inter min-h-screen relative"
      style={{
        background:
          "linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)",
        backgroundColor: "rgb(23,39,92)",
      }}
    >
      <div className="sm:col-span-6 flex justify-center items-center text-3xl rounded-xl p-2 "></div>
      <div
        className="sm:col-span-4 flex justify-center items-center text-3xl  p-2 border-l-2"
        style={{ borderColor: "#214471" }}
      >
        <div className="w-fit flex justify-center">
          <form
            className="flex flex-col w-full items-center"
            onSubmit={handleSubmit}
          >
            <h1 className="text-white font-semibold text-3xl mb-10 text-center">
              Login
            </h1>
            <div className="flex flex-col mb-4 w-96">
              <InputLabel
                className="text-white mb-1 text-base"
                style={{ color: "white" }}
              >
                Email
              </InputLabel>
              <TextField
                id="email"
                type="email"
                variant="outlined"
                size="small"
                placeholder="Email"
                name="email"
                autoComplete="off"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                InputProps={{
                  style: {
                    background: "white",
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
                  },
                }}
              />
            </div>
            <div className="flex flex-col mb-4 w-96">
              <label className="text-white mb-1 text-base ">Password</label>
              <TextField
                id="password"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                size="small"
                className={`mt-2 -not-acursorllowed `}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                // readOnly
                error={!!passwordError}
                helperText={passwordError}
                style={{ cursor: "not-allowed" }}
                // onCopy={(e) => e.preventDefault()}
                // onCut={(e) => e.preventDefault()}
                // onPaste={(e) => e.preventDefault()}
                InputProps={{
                  style: {
                    background: "white",
                    //boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleTogglePasswordVisibility}>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                placeholder="Password"
              />
              <p className="text-white text-sm my-5 flex justify-end">
                <a href="/forgotpassword" className=" border-b-2  inline-block">
                  Forgot Password
                </a>
              </p>
            </div>
            <button
              type="submit"
              variant="contained"
              color="primary"
              className="w-32 h-8 rounded-md mb-2 font-bold text-lg text-dark-blue text-sm bg-white"
              style={{
                backgroundColor: "white",
                fontWeight: "bold",
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
              }}
            >
              Continue
            </button>

            <p className="text-white text-base mt-5">
              Don't have an account?{" "}
              <a
                href="/signup"
                className="text-white border-b-2 text-base ml-1"
              >
                Sign Up
              </a>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
